import { useState } from "react"

function readIds(key: string): string[] {
  try {
    // Чужие значения безвредны: показываются только id, которые есть в текущем списке.
    const parsed: unknown = JSON.parse(localStorage.getItem(key) ?? "[]")
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === "string") : []
  } catch {
    return []
  }
}

/** Список id в localStorage: избранное, недавнее, скрытое в панелях оболочки. */
export function useStoredIds(key: string) {
  const [ids, setIds] = useState(() => readIds(key))
  const update = (next: string[]) => {
    setIds(next)
    try {
      localStorage.setItem(key, JSON.stringify(next))
    } catch {
      // Без localStorage (приватный режим) список живёт до перезагрузки.
    }
  }
  return [ids, update] as const
}
